import importerReducers from 'modules/shared/importer/importerReducers';
import actions from 'modules/compartiment/importer/compartimentImporterActions';

export default importerReducers(actions);
